import { TagsPageHeader } from '@pages/Tags/components';
import { Tags } from '@pages/Tags/Tags.main';

export { Tags, TagsPageHeader };
